import React from 'react'
import "./Experience.css"
import { AiFillCheckCircle } from 'react-icons/ai'

const Experience = () => {
    return (
        <section id="experience">
            <h2><b>Expertise</b></h2>

            <div className=" container experience__container">

                {/* Technical Skills */}


                <div className="experience__technical">
                    <h3>Technical Skills</h3>
                    <div className="experience__content">
                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Hardware Troubleshooting</h4>
                            </div>
                        </article>

                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Software Installation and Configuration</h4>
                            </div>
                        </article>

                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Network Troubleshooting</h4>
                            </div>
                        </article>

                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Peripheral Devices Management (Printers, Scanners, etc.)</h4>
                            </div>
                        </article>



                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Configuring network interfaces, firewall rules, and VPN connections.</h4>
                            </div>
                        </article>

                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>System administration, including installation, configuration, and maintenance </h4>
                            </div>
                        </article>
                    </div>

                </div>

                {/* Personal Skills */}

                <div className="experience__personal">
                    <h3>Personal Skills</h3>
                    <div className="experience__content">
                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Excellent written and verbal communication skills</h4>

                            </div>
                        </article>

                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Ability to work independently or as part of a team</h4>

                            </div>
                        </article>

                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Problem-solving abilities</h4>

                            </div>
                        </article>

                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Active Listening Skills</h4>

                            </div>
                        </article>

                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Time Management Skills</h4>

                            </div>
                        </article>
                        <article className='experience__details'>
                            <AiFillCheckCircle size={20} className='experience__details-icons' />
                            <div>
                                <h4>Adaptability to New Technologies</h4>

                            </div>
                        </article>
                    </div>

                </div>

            </div>
        </section>
    )
}

export default Experience